import { contactUsHeroImage, contactUsHeroImageMobile } from "../images";

export const heroData = [
	{
		imageSource: [contactUsHeroImage, contactUsHeroImageMobile],
		heading: "Contact Us",
	},
];
